module.exports = __webpack_public_path__ + "img/slide-1-image@3x.7599ac88.jpg";